import { useAuth0 } from '@auth0/auth0-react'

const useAuth0Wrapper = () => {
  // Mock the hook only for regression tests
  const isCypressRegression = window.Cypress
  // It's possible to decide in cypress tests the behaviour
  const isAuthenticatedMock =
    window.Cypress?.env('auth0isAuthenticated') || false
  const { loginWithRedirect, isAuthenticated, isLoading, user } = useAuth0()

  return isCypressRegression
    ? {
        isAuthenticated: isAuthenticatedMock,
        isLoading: false,
        loginWithRedirect: () => {},
      }
    : {
        loginWithRedirect,
        isAuthenticated,
        isLoading,
        user,
      }
}
export default useAuth0Wrapper
